export default "__VITE_PUBLIC_ASSET__1bae54fb__"